(() => {
  let timer;
  const expire=()=>{
    clearTimeout(timer);
    const now=Date.now()/1000;
    document.querySelectorAll('[data-simple-expiry],[data-simple-image-expiry]').forEach(node=>{
      const end=Number(node.dataset.simpleExpiry||node.dataset.simpleImageExpiry);
      if(!Number.isFinite(end)||end<=now){if(node.matches('[data-simple-expiry]')){node.querySelectorAll('[data-simple-offer]').forEach(e=>e.hidden=true);const fallback=node.querySelector('[data-simple-price-fallback]');if(fallback)fallback.hidden=false;}else node.hidden=true;}
    });
    const dates=[...document.querySelectorAll('[data-simple-expiry],[data-simple-image-expiry]')].map(n=>Number(n.dataset.simpleExpiry||n.dataset.simpleImageExpiry)*1000).filter(n=>n>Date.now());
    if(dates.length)timer=setTimeout(expire,Math.min(Math.min(...dates)-Date.now()+100,2147483647));
  };
  expire();document.addEventListener('visibilitychange',expire);
})();
